import config from '@/config/index';

/**
 * 增加专家
 *
 * @param binduid          待绑定uid
 * @param name             姓名
 * @param profile          履历简介
 * @param signature        签名一句话
 * @param industrycategory 行业分类
 * @param age              年龄
 * @param organization     所属结构名称
 * @param position         职位
 * @param grade            职称
 * @param isopen           是否公开信息
 * @param request
 * @return
 */
function addSpecialist() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/specialist`;
}
/**
 * 修改专家信息
 *
 * @param sid              专家id
 * @param binduid          待绑定uid
 * @param name             姓名
 * @param profile          履历简介
 * @param signature        签名一句话
 * @param industrycategory 行业分类
 * @param age              年龄
 * @param organization     所属结构名称
 * @param position         职位
 * @param grade            职称
 * @param isopen           是否公开信息
 * @param request
 * @return
 */
function modifySpecialist() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/modifyspecialist`;
}

/**
 * 获取专家详情
 *
 * @param sid     专家ID
 * @param request
 * @return
 */
function getSpecialist(sid) {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/specialist/${sid}`;
}

/**
 * ES搜索 -  专家搜索
 * @param grade
 * @param industrycategory
 * @param page           当前第几页
 * @param limit          限制多少页
 *  @GetMapping("/searchspecialist")
 */
function searchspecialist() {
  return `${config.HOST_API}${config.OP_API_PREFIX}/searchspecialist`;
}

/**
 * 发布找专家需求
 *
 * @param category 专家专业领域
 * @param edu_bg   '专家学历'
 * @param province 省份
 * @param district 地区
 * @param contacts 联系人
 * @param mobile   电话
 * @param content  留言内容
 * @return@PostMapping("/specialistaskfor")
 */
function specialistaskfor() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/specialistaskfor`;
}

/**
 * 获取找专家需求的回答列表
 * 管理员和提问者可以看到答案
 *
 * @param aid     找专家需求ID
 * @param request
 * @return@GetMapping("/specialistaskforanswerlist")
 */
function specialistaskforanswerlist() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/specialistaskforanswerlist`;
}

/**
 * 获取用户发起过的找专家需求列表（前端用）
 * @param page
 * @param limit
 * @param request
 * @return@GetMapping("/myspecialistaskforlist")
 */
function getMySpeciallistAskForList(){
  return `${config.HOST_API}${config.BASE_API_PREFIX}/myspecialistaskforlist`;
}
//
export {
  addSpecialist,
  modifySpecialist,
  getSpecialist,
  searchspecialist,
  specialistaskfor,
  specialistaskforanswerlist,
  getMySpeciallistAskForList
};
